import { Formik, useField } from 'formik';
import { useProjectAddShortlistStageMutation } from 'generated/graphql';
import * as yup from 'yup';
import { STAGE_NAME_MAX_LENGTH } from 'views/Project/components/Stages/helpers';
import {
  EditFormWrapper,
  FormikTextInputField,
  TNotification,
  useNotification,
} from '@spotted-zebra-uk/ui-components';
import styles from './ShortlistStageForm.module.scss';

type ShortlistStageFormProps = {
  onCancel: () => void;
  onSubmit: () => void;
  projectSubId: string;
};

type ShortlistStageFormValues = {
  name: string;
};

export default function ShortlistStageForm({
  onCancel,
  onSubmit,
  projectSubId,
}: ShortlistStageFormProps) {
  const { handleMsgType } = useNotification();
  const [addShortlistStage] = useProjectAddShortlistStageMutation({
    onCompleted: () => {
      handleMsgType({
        type: TNotification.success,
        title: 'Shortlist stage created successfully',
      });
      onSubmit();
    },
    onError: (error) => {
      handleMsgType({ type: TNotification.error, message: error?.message });
    },
  });
  const handleCancel = () => {
    onCancel();
  };

  const handleSave = async (values: ShortlistStageFormValues) => {
    addShortlistStage({
      variables: {
        subId: projectSubId,
        name: values.name,
      },
    });
  };

  const initialValues = {
    name: '',
  };

  const validationSchema = yup.object().shape({
    name: yup
      .string()
      .required()
      .max(STAGE_NAME_MAX_LENGTH, `Must be ${STAGE_NAME_MAX_LENGTH} characters or less`),
  });

  return (
    <Formik<ShortlistStageFormValues> initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSave}>
      {({ handleSubmit, values }) => (
        <EditFormWrapper
          title="Create shortlist stage"
          hasResetAllButton={false}
          onCancelClick={handleCancel}
          onSaveClick={handleSubmit}
        >
          <div className={styles.container}>
            <h3 className={styles.sectionTitle}>General</h3>
            <FormikTextInputField
              id="name"
              name="name"
              label="Shortlist stage name"
              placeholder="Shortlist stage name"
              required
              useFormikField={useField}
              maxLength={STAGE_NAME_MAX_LENGTH}
              maxCharacters={STAGE_NAME_MAX_LENGTH}
              maxCharactersError={values.name.length >= STAGE_NAME_MAX_LENGTH}
            />
          </div>
        </EditFormWrapper>
      )}
    </Formik>
  );
}